import React from 'react';
import { Table, Button, Tag } from 'antd';
import {CopyOutlined} from "@ant-design/icons";
import moment from 'moment'; // Import moment for date formatting
import ProspectEmailFormat from "./ProspectEmailFormat";
import copyClipboard from "../../utils/copyClipboard";

const ProspectTable = ({ prospects, onManagePortfolios, onEditProspect }) => {
    const formatInviteMessage = (email) => {
        return `Please use the link below to login to your FINIAT IQ.\r\nYour username is: ${email}`;
    }

    const columns = [
        { title: 'Name', dataIndex: 'name', key: 'name' },
        { title: 'Email', dataIndex: 'email', key: 'email' },
        {
            title: 'Sessions Count',
            dataIndex: 'sessions_count',
            key: 'sessions_count',
            render: (text) => text ? `${text} logins` : 'No data',
        },
        {
            title: 'Last Login',
            dataIndex: 'last_session',
            key: 'last_login',
            render: (lastSession) => lastSession ? moment.unix(lastSession.start_time).format('YYYY-MM-DD HH:mm:ss') : 'No data',
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <>
                    <Button onClick={() => onManagePortfolios(record)}>Manage Portfolios</Button>
                    <Button style={{ marginLeft: '10px' }} onClick={() => onEditProspect(record)}>Edit</Button>
                </>
            ),
        },
        {
            title: "Send Invite",
            key: "send_invite",
            render: (_, record) => <ProspectEmailFormat
                email={record.email}
                title={'FINIAT IQ Login'}
                message={formatInviteMessage(record.email)}
                url={'https://dev.iaplatform.app'}
            />
        },
        {
            title: "Copy",
            key: "copy_url",
            render: (_, record) => <Button onClick={() => copyClipboard(record.email)} icon={<CopyOutlined/>}/>
        }
    ];

    return <Table dataSource={prospects} columns={columns} rowKey="user_id" />;
};

export default ProspectTable;
